import { createPortal } from "react-dom";

const QmsModalPortal = ({ children }) => {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
};

export default QmsModalPortal;
